import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastService} from '../../services/toast.service';
import {ModalController} from '@ionic/angular/lazy';
import {EventService} from '../../services/event.service';
import {EventReadonly} from '../../api/models/event-readonly';
import {ExhibitorService} from '../../services/exhibitor.service';

@Component({
  standalone: false,
  selector: 'app-desk-order',
  templateUrl: './desk-order.component.html',
  styleUrls: ['./desk-order.component.scss'],
})
export class DeskOrderComponent implements OnInit {

  events: Array<EventReadonly>;
  deskOrderForm: FormGroup;

  constructor(public formBuilder: FormBuilder,
              private eventService: EventService,
              private exhibitorService: ExhibitorService,
              private toast: ToastService,
              private modal: ModalController) {

    this.deskOrderForm = this.formBuilder.group({
      event: ['', [Validators.required]],
      amount_desks: ['', [Validators.required, Validators.min(0), Validators.max(10)]],
      amount_squaremeters: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
    }, {});
  }

  ngOnInit() {
    this.eventService.getEventList().subscribe(
      x => {this.events = x.results}
    )
  }

  cancel() {
    this.modal.dismiss(null, 'cancel');
  }

  orderDesks(){

    this.exhibitorService.orderDesks({ event: { id: this.deskOrderForm.value.event.id,
      start: null, end: null, name: null, state: null},
      amount_desks: this.deskOrderForm.value.amount_desks,
      amount_squaremeters: this.deskOrderForm.value.amount_squaremeters,
      id: null}).subscribe(
      x => {
        this.toast.presentToast('Tischbestellung gespeichert', 'success')
        this.modal.dismiss({});
      }, error => {
        this.toast.readAnyErrorValues(error);
      });


  }

}
